var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-suggestion"},_vm._l((_vm.suggestions),function(suggestion,index){return _c('p',{on:{"mousedown":function($event){return _vm.$emit('select-suggestion', index)}}},[_vm._v(_vm._s(suggestion))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }